import script from "./Rfid.vue?vue&type=script&setup=true&lang=js"
export * from "./Rfid.vue?vue&type=script&setup=true&lang=js"

import "./Rfid.vue?vue&type=style&index=0&id=caf7c262&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caf7c262"]])

export default __exports__